/* eslint-disable no-unused-vars */
import React from "react";
import { useDispatch } from "react-redux";
import {isIconButnActive}  from "../Services/Redux/Reducers/commonSlice";

function FaqBeta() {
    const dispatch = useDispatch();

    return (
        <div id="faqCanvas" className="usersection_faqbeta px-4 mx-1 py-2">
            <div className="faq-beta">
                <div className="faq-header">FAQ's</div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">WHAT IS ASK RALPH?</div>
                <div className="faq-content">
                Developed by Ralph Lauren, Ask Ralph is an AI-powered styling assistant that offers personalized fashion guidance and a streamlined shopping experience. It is our latest innovation in conversational commerce, using machine learning and natural language processing to understand and assist you with your style choices.
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">WHO IS THIS AVAILABLE TO?</div>
                <div className="faq-content">
                Currently, the Ask Ralph tool is available exclusively to Ralph Lauren App account holders in the United States. Be sure to share any feedback you may have with us, as it will be incorporated into future Ask Ralph enhancements.
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">ARE ALL PRODUCTS AVAILABLE WITHIN THE ASK RALPH STYLING ASSISTANT?</div>
                <div className="faq-content">
 At this time, Ask Ralph will only recommend products from our men’s and women’s Polo Ralph Lauren brand.
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">WHAT CAN THE ASK RALPH STYLIST DO?</div>
                <div className="faq-content">
                Ask Ralph is your personal AI stylist, made to assist you in your shopping journey. Whether you’re looking for outfit inspiration for a glamorous party or searching for the perfect gift, Ask Ralph is here to help. Whether asking, “What should I wear for a wedding in the Hamptons next March?” or “Show me different tops featuring the Polo Bear” or “What gift ideas do you have for a friend?”, Ask Ralph is designed to answer all of these questions and more, making your shopping experience seamless and enjoyable. 
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">HOW DOES ASK RALPH WORK AND COME UP WITH ITS ANSWERS?</div>
                <div className="faq-content">
                Ask Ralph works by using artificial intelligence to interact with you in a conversational manner. When you ask a question or make a request, the AI analyzes your input and draws from its extensive knowledge of Ralph Lauren’s products, brand knowledge, style guidelines, and information across the web to offer recommendations. You can refine your requests by providing more details and Ask Ralph will adapt its suggestions accordingly. Please note that Ask Ralph is designed to act solely as a styling assistant, so please refrain from asking financial, medical, legal, or any other derogatory and inappropriate information. Please avoid disclosing any personal or sensitive information, too.  
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">HOW ACCURATE ARE THE AI STYLIST'S SUGGESTIONS?</div>
                <div className="faq-content">
                As we continue to evolve Ask Ralph, there will be instances where the responses are not 100 percent accurate or aligned with our RalphLauren.com or in-store experiences. If this is the case, please report these instances using the thumbs up/thumbs down feedback mechanisms, located directly in the chat.  
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">HOW DO I FIND THE RIGHT OUTFIT FOR A SPECIFIC OCCASION? (e.g., wedding, job interview)</div>
                <div className="faq-content">
                To find the right outfit for a specific occasion, you can simply tell Ask Ralph about the event you are attending, your style preferences, sizes, and any other requirements. Ask Ralph will present you with a curated selection of Ralph Lauren attire that fits your needs, offering options for different looks and suggesting complete outfits to ensure you are dressed for the occasion.
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">WHAT SHOULD I DO IF THE VIRTUAL STYLIST DOES NOT UNDERSTAND MY REQUESTS?</div>
                <div className="faq-content">If Ask Ralph does not understand your requests, try to provide more specific information, or use simpler, clearer language. Ensure that you are being direct with your questions or requests. The more detailed your question the better the response will be.
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">IS THERE A LIMIT TO HOW MANY TIMES I CAN USE THE ASK RALPH STYLIST?</div>
                <div className="faq-content">There is no limit to how many times you can use the stylist. There is a timeout period in which due to inactivity your chat conversation will be saved and stored in chat history. 
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">HOW CAN I ACCESS AND CLEAR MY CHAT HISTORY?</div>
                <div className="faq-content">Chat history will be stored and accessible through the main home page of Ask Ralph. Upon clicking on one of the chats, you will be able to review or delete previous chat history. Currently there is no ability to re-engage with a chat and input new questions or responses. Clearing chat history removes questions and responses from that specific chat. 
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">CAN I SAVE MY FAVORITE OUTFITS OR RECOMMENDATIONS?</div>
                <div className="faq-content">
                There is no direct feature to save outfits and store them. However, all conversations will be stored in your chat history for you to reference previous outfit and product recommendations.
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">CAN THE AI STYLIST CONSIDER MY EXISTING WARDROBE?</div>
                <div className="faq-content">
                    Currently, Ask Ralph does not take into consideration your personal wardrobe or any past Ralph Lauren purchases you have made.  
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">IS THE VIRTUAL STYLIST AVAILABLE IN MULTIPLE LANGUAGES?</div>
                <div className="faq-content">Currently, Ask Ralph is only available in English within The Ralph Lauren App in the United States. Multi-language support may be considered in future expansions. 
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">WHY DID I GET A RESPONSE THAT DID NOT DIRECTLY ANSWER MY QUESTION?</div>
                <div className="faq-content">There are multiple reasons why Ask Ralph may not answer a question. Ask Ralph is mainly a styling and brand knowledge tool. Certain responses may not be available right now, but we are actively working to expand and answer more questions. Ask Ralph may choose not to respond to certain questions due to the inappropriate nature of them or if it is outside of our brand guidelines. 
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">WHAT SHOULD I DO IF I'M NOT SATISFIED WITH THE RECOMMENDATIONS?</div>
                <div className="faq-content">If you are not satisfied with a recommendation, please provide feedback through the thumbs up/thumbs down mechanisms located directly in the chat. Then, treat this experience as a conversation and provide more context, reword the question, or ask follow-up questions. 
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">HOW CAN I PROVIDE FEEDBACK ON THE AI STYLIST'S RECOMMENDATIONS?</div>
                <div className="faq-content">To provide feedback on your recommendation, use the thumbs up/thumbs down mechanisms located directly in the chat to determine the recommendation’s quality as it relates to your input. This will allow us to continue to improve our tool over time and enhance your experience with Ask Ralph.
                </div>
            </div>

            <div className="faq-beta">
                <div className="faq-title">PRIVACY AND SECURITY</div>
            </div>

            <div className="faq-beta">
                <div className="faq-title">WHAT PERSONAL INFORMATION DOES THE VIRTUAL STYLIST COLLECT?</div>
                <div className="faq-content">
                Ask Ralph will store information related to the chat history of the conversation, as well as any feedback you provide through the use of the assistant. Your email address is also stored for authentication purposes. The feedback provided, regarding recommendations and the Ask Ralph tool, will be collected and analyzed to improve the quality of the assistant. At present, the tool does not collect information related to your customer profile with us and only relies on chat conversation to provide recommendations
                </div>
            </div>

            <div className="faq-beta">
                <div className="faq-title">IS MY PERSONAL INFORMATION SECURE WHEN USING THE TOOL?</div>
                <div className="faq-content">Yes, personal information remains in the Ralph Lauren cloud landscape, where it is encrypted and stored. Your personal information is not shared with third parties as a result of using the tool. Your personal information is not transferred outside of North America as part of the tool’s use.
                </div>
            </div>
            <div className="faq-beta">
                <div className="faq-title">HOW CAN I LEARN MORE ABOUT HOW MY PERSONAL DATA IS USED AND PROCESSED?</div>
                <div className="faq-content">If you want to learn more about how your personal data can be used by Ralph Lauren,
                    please read our privacy policy  <a href="https://www.ralphlauren.com/customerservice?cid=cs-privacy-notice" target="_blank" rel="noopener noreferrer"> here</a>, or contact us at
                    <a href="mailto:privacy@ralphlauren.com" target="_blank" rel="noopener noreferrer"> privacy@ralphlauren.com.</a>
                </div>
            </div>
            <div className="faq-gradient"></div>
            <div className="offcanvas-header d-flex justify-content-end"
                style={{  position: "fixed", bottom: "40px", left: "50%",transform: "translateX(-50%)", zIndex: "1000" }}>                                           
                <button
                    name="closeButton"
                    type="button"
                    className=""
                    onClick={()=>{dispatch(isIconButnActive(false))}}
                    data-bs-dismiss="offcanvas"
                    style={{
                        backgroundColor: "#e1e1dc",
                        borderRadius: "50%",
                        padding: "0",
                        width: "40px",
                        height: "40px",
                        border: "none",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <img src="/static/assets/close.svg" alt="close" height="16px" width="16px" />
                </button>
            </div>
        </div>
    );
}

export default FaqBeta;